"use client";

import { useEffect, useRef, useState } from "react";

/** The venue's photos as a grid; one opens large, with previous and next. */
export function GuidePhotoGallery({
  photos,
  name,
  copy,
}: {
  photos: string[];
  name: string;
  copy: { open: string; close: string; prev: string; next: string; of: string };
}) {
  const dialogRef = useRef<HTMLDialogElement>(null);
  const [index, setIndex] = useState<number | null>(null);

  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return;
    if (index !== null && !dialog.open) dialog.showModal();
    if (index === null && dialog.open) dialog.close();
  }, [index]);

  const step = (by: number) => setIndex((i) => (i === null ? null : (i + by + photos.length) % photos.length));

  return (
    <>
      <div className="eg-gallery">
        {photos.map((src, i) => (
          <button key={src} type="button" onClick={() => setIndex(i)} aria-label={`${copy.open}: ${name} ${i + 1}`}>
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img src={src} alt="" loading="lazy" decoding="async" />
          </button>
        ))}
      </div>
      <dialog
        ref={dialogRef}
        className="eg-lightbox"
        aria-label={name}
        onClose={() => setIndex(null)}
        onClick={(event) => {
          if (event.target === dialogRef.current) setIndex(null);
        }}
        onKeyDown={(event) => {
          if (event.key === "ArrowRight") step(1);
          if (event.key === "ArrowLeft") step(-1);
        }}
      >
        {index !== null ? (
          <div className="eg-lightbox__stage">
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img src={photos[index]} alt={`${name} ${index + 1}`} />
            {photos.length > 1 ? (
              <>
                <button type="button" className="eg-lightbox__button eg-lightbox__button--prev" onClick={() => step(-1)} aria-label={copy.prev}>
                  ‹
                </button>
                <button type="button" className="eg-lightbox__button eg-lightbox__button--next" onClick={() => step(1)} aria-label={copy.next}>
                  ›
                </button>
              </>
            ) : null}
            <button type="button" className="eg-lightbox__close" onClick={() => setIndex(null)}>
              {copy.close}
            </button>
            <span className="eg-lightbox__count" dir="ltr">
              {index + 1} {copy.of} {photos.length}
            </span>
          </div>
        ) : null}
      </dialog>
    </>
  );
}
